import template from './accordion.html';
import './accordion.global.css';

class AccordionController {
  $onInit() {
    this.expanded = this.expanded || [];
  }

  $onChanges(changes) {
    const {
      items: { currentValue: items },
    } = changes;

    if (items) {
      this.expanded =
        (items && items.filter(item => item.expanded).map(item => item.id)) ||
        [];
    }
  }

  toggleId(id) {
    if (this.isExpanded(id)) {
      this.expanded = this.expanded.filter(i => i !== id);
    } else {
      this.expanded.push(id);
    }

    this.change({ $value: this.expanded });
  }

  isExpanded(id) {
    return this.expanded.indexOf(id) !== -1;
  }
}

export const AccordionComponent = {
  controller: AccordionController,
  bindings: {
    items: '<',
    change: '&',
    itemClick: '&',
  },
  transclude: true,
  template,
};
